var _use, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlagOfNepal(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    width: 726,
    height: 885,
    viewBox: "-17.582 -4.664 71.571 87.246",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Flag of Nepal") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    stroke: "#003893",
    strokeWidth: 5.165
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M -15,37.5735931288 h 60 L -15,0 v 80 h 60 L -15,20 z",
    fill: "#DC143C"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -11.9502769431,23.4834957055 A 12.8400974233,12.8400974233 0 0,0 11.9502769431,23.4834957055 A 11.9502769431 11.9502769431 0 0,1 -11.9502769431,23.4834957055"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 29.045) scale(5.56106)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "d"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M 0.195090322016,-0.980785280403 L 0,-1.388784109750 L -0.195090322016,-0.980785280403",
    transform: "rotate(11.25)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    transform: "rotate(22.5)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    transform: "rotate(45)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    transform: "rotate(67.5)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    transform: "scale(-1 1)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(8.1434 0 0 8.1434 0 58.787)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "g"
  }, /*#__PURE__*/React.createElement("g", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    id: "e",
    d: "M 0.258819045103,0.965925826289 L 0,1.576749285537 L -0.258819045103,0.965925826289"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e",
    transform: "rotate(180)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f",
    transform: "rotate(90)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g",
    transform: "rotate(30)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g",
    transform: "rotate(60)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagOfNepal);
export default __webpack_public_path__ + "static/media/Flag_of_Nepal.4882e21235bab13d742b08d2c20e082a.svg";
export { ForwardRef as ReactComponent };